import React, { FC, ReactElement } from "react";
import { CSSTransition } from "react-transition-group";

import { StyledSlideLeftRight } from "./Styles";
import { TransitionProps } from "../types";

interface ISlideLeftRightTransition extends TransitionProps {
  children: ReactElement;
  direction?: "left" | "right";
}

export const SlideLeftRightTransition: FC<ISlideLeftRightTransition> = ({
  children,
  direction = "left",
  ...props
}) => {
  return (
    <CSSTransition timeout={200} classNames="c-slide" unmountOnExit {...props}>
      <>
        {children}
        <StyledSlideLeftRight $direction={direction} />
      </>
    </CSSTransition>
  );
};

SlideLeftRightTransition.displayName = "SlideLeftRightTransition";
